import React from "react";
import type { JSX } from "react";
import { Outlet, useLocation } from "react-router";

declare global {
    interface Window {
        QSI?: {
            API: {
                unload: () => void;
                load: () => void;
                run: () => void;
            };
            isDebug: boolean;
        };
    }
}

export default function QualtricsMiddleware(): JSX.Element {
    const location = useLocation();

    async function loadQualtrics() {
        if (typeof window.QSI !== "undefined") {
            window.QSI.API.unload();
            window.QSI.API.load();
            window.QSI.API.run();
        } else {
            const checkQualtrics = setTimeout(function () {
                loadQualtrics();
                clearTimeout(checkQualtrics);
            }, 3000); // delay 3 sec
        }
    }

    React.useEffect(() => {
        loadQualtrics();
    }, [location]); // Whenever location changes

    return <Outlet />;
}
